import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { FormsGlobals } from 'src/app/models/forms/forms.enum';

@Component({
  selector: 'app-case-item-form-remove-cancel',
  templateUrl: './case-item-form-remove-cancel.component.html',
  styleUrls: ['./case-item-form-remove-cancel.component.css']
})
export class CaseItemFormRemoveCancelComponent implements OnInit {

  message: string = '';
  CaseWorkItemID: string = '';
  CaseWorkItemFormID: string = '';
  enumFormCompletionStatus: string = '';
  enumCaseWorkItemStatusID: string = '';
  canDelete: boolean = true;
  formStarted: boolean = false;

  caseWorkItemStatusPending = '00000167-1000-0000-0000-000000000001';

  constructor(
    public dialogRef: MatDialogRef<CaseItemFormRemoveCancelComponent>,
    private formsGlobals: FormsGlobals,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data.enumFormCompletionStatus)
    {
      if (this.data.enumFormCompletionStatus !== this.formsGlobals.STATUS_NOT_STARTED) {
        // form has been started
        this.formStarted = true;
      }
      else {
        // form has not been started
        this.formStarted = false;
      }
    }
    else if (this.data.enumCaseWorkItemStatusID)
    {
      if (this.data.enumCaseWorkItemStatusID !== this.caseWorkItemStatusPending) {
        // disable delete button
        this.canDelete = false;
      }
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }

  markAsCanceled() {
    this.dialogRef.close('cancel');
  }

  delete() {
    this.dialogRef.close('delete');
  }

}
